module.exports = __webpack_public_path__ + "media/images/lb/839-c4cfe18bccef49b0841dff4935e4f73b.svg";